import { generateSlug } from '@bonanza-social/toolkit/utils';
import { Promo } from '../welcomePromos.types';

export const mapPromos = (promos: Promo[]) =>
  promos.map((promo) => ({
    ...promo,
    slug: generateSlug(promo.title),
  }));
